import ReactOnRails from 'react-on-rails';

import HostSignUp from '../bundles/HostSignUp/startup/registration';

ReactOnRails.register({
  HostSignUp,
});
